import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { getData, patchData } from "src/utils/axios/serverHelper";
import { HRM3040_R01Dto, HRM3040_R01PreviewDto } from "./Dto_HRM3040_R01";
import { HRM3040_R01Filter } from "./Store_HRM3040_R01";

// 화면의 모든 요청에서 사용하는 API 경로이다.
const baseUrl = `${config.apiUrl}/HRM3040_R01`;

/** 기준일·표시 조건의 두 기준 목록 응답을 반환한다. 사업장·부서는 기준표에 적용하지 않는다. */
export const getHRM3040_R01List = async (option: string, params: Partial<HRM3040_R01Filter>) =>
    await getData<ResponseDto<HRM3040_R01Dto>>(`${baseUrl}/${option}`, { params: { baseDt: params.baseDt, scope: params.scope } });
/** 기준일·사업장·부서 조건의 재직자 계산 결과 응답을 반환한다. 빈 사업장·부서는 요청에서 제외한다. */
export const getHRM3040_R01PreviewList = async (option: string, params: Partial<HRM3040_R01Filter>) =>
    await getData<ResponseDto<HRM3040_R01PreviewDto[]>>(`${baseUrl}/preview/${option}`,
        { params: { baseDt: params.baseDt, compCd: params.compCd || undefined, orgCd: params.orgCd || undefined } });
/** 두 기준표의 신규·수정·삭제를 요청 하나로 저장한 완료 응답을 반환한다. */
export const patchHRM3040_R01 = async (data: HRM3040_R01Dto) =>
    await patchData<HRM3040_R01Dto, ResponseDto<void>>(baseUrl, data);
/** 마지막 조회 조건을 복사해 3시트 XLSX 응답을 반환한다. */
export const downloadExcel_HRM3040_R01 = async (option: string, params: Partial<HRM3040_R01Filter>) =>
    await getData<ResponseDto<string>>(`${baseUrl}/excel/${option}`, { params: { ...params } });
